import React, { useState, useImperativeHandle, forwardRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import style from "./IOExecution.module.scss";
import InlineDetail from "../../IO/InlineItem";
import { IOMode, IOType } from "../../IO/types";
import Securities, { validateSecurities } from "./Securities";

const IOExecution = forwardRef(({ io, services, validate }, ref) => {
  const [items, setItems] = useState(io.items);
  const [errors, setErrors] = useState({});

  useImperativeHandle(ref, () => ({
    validate() {
      let hasErrors = false;

      if (io.IOType != IOType.Transfer) {
        const newErrors = validateSecurities(items);

        setErrors(newErrors);

        Object.values(newErrors).forEach((f) => {
          Object.keys(f).forEach((e) => {
            if (e != undefined) {
              hasErrors = true;
            }
          });
        });
      }

      return hasErrors;
    },
    getValues() {
      if (io.IOType != IOType.Transfer) {
        return items.map((item) => ({
          key: item.Id,
          value: item.CustodianId,
        }));
      }
    },
  }));

  const onChange = (id, values) => {
    setItems(
      items.map((item) => {
        if (item.Id === id) {
          return {
            ...item,
            ...values,
          };
        }
        return item;
      })
    );

    const cleanedErrors = {};
    Object.keys(values).forEach((key) => (cleanedErrors[key] = undefined));

    const newErrors = {
      [id]: {
        ...(errors[id] || {}),
        ...cleanedErrors,
      },
    };

    setErrors(newErrors);
    return newErrors;
  };

  return (
    <div className={style.content}>
      {true && <Securities io={io} items={items} errors={errors} onChange={onChange} services={services} />}
    </div>
  );
});

export default IOExecution;
